import { render, staticRenderFns } from "./PxCamposCompraItemUseallSetup.vue?vue&type=template&id=cce6adc6&"
import script from "./PxCamposCompraItemUseallSetup.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemUseallSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports